/**
 * CCW Cart Add-on (CHR-26)
 *
 * 1. Add button: posts the add-on variant to /cart/add.js with the cart sections bundled,
 *    then hands the response to the theme's cart pub/sub so the drawer and cart page
 *    re-render themselves (the card disappears because the product is now in the cart).
 * 2. Trim resolution: when a bundle lists two brackets (mixed-trim RZR kits), read the
 *    vehicle the shopper saved in the finder (localStorage, same keys as ccw-garage.js).
 *    If that saved vehicle routes to the bundle in the cart and its trim matches exactly
 *    one card's data-trims list, hide the other card and the "pick your trim" line.
 *    Unknown or ambiguous = both cards stay. No JS = both cards.
 *
 * Debug: window.CCWCartAddon.resolve() / .garage()
 */
(function () {
  'use strict';

  var SECTIONS = 'cart-drawer,cart-template,cart-count';

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ---------- garage (vehicle finder) state ---------- */
  function garage() {
    var data = window.__CCW_GARAGE__ || {};
    var prefix = (data.config && data.config.storagePrefix) || 'ccw_garage_';
    function get(k) { try { return localStorage.getItem(prefix + k); } catch (e) { return null; } }
    return {
      year: parseInt(get('year'), 10) || null,
      make: get('make'),
      trim: get('trim_label'),
      entries: Array.isArray(data.entries) ? data.entries : []
    };
  }

  // Does the saved vehicle route to this bundle handle?
  function savedVehicleRoutesTo(g, bundleHandle) {
    if (!g.trim || !bundleHandle) return false;
    for (var i = 0; i < g.entries.length; i++) {
      var e = g.entries[i];
      if (!e || e.route_product_handle !== bundleHandle) continue;
      if (!Array.isArray(e.trims) || e.trims.indexOf(g.trim) === -1) continue;
      if (g.year && (g.year < e.year_start || g.year > e.year_end)) continue;
      return true;
    }
    return false;
  }

  function parseTrims(card) {
    var raw = card.getAttribute('data-trims');
    if (!raw) return [];
    try { var v = JSON.parse(raw); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }

  function resolve() {
    var g = garage();
    var groups = document.querySelectorAll('[data-ccw-addon-group]');
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      var cards = group.querySelectorAll('[data-ccw-addon-card]');
      if (cards.length < 2) continue;
      // reset any previous resolution (sections re-render fresh, but be safe)
      for (var r = 0; r < cards.length; r++) cards[r].hidden = false;
      var head = group.querySelector('[data-ccw-addon-head]');
      if (head) head.hidden = false;

      if (!g.trim) continue;
      if (!savedVehicleRoutesTo(g, group.getAttribute('data-bundle-handle'))) continue;

      var matches = [];
      for (var c = 0; c < cards.length; c++) {
        if (parseTrims(cards[c]).indexOf(g.trim) !== -1) matches.push(cards[c]);
      }
      if (matches.length !== 1) continue;

      for (var h = 0; h < cards.length; h++) cards[h].hidden = cards[h] !== matches[0];
      if (head) head.hidden = true;
    }
  }

  /* ---------- add to cart ---------- */
  function setBusy(btn, busy) {
    if (!btn) return;
    btn.disabled = !!busy;
    btn.setAttribute('aria-busy', busy ? 'true' : 'false');
    if (busy) { btn.dataset.ccwLabel = btn.textContent; btn.textContent = 'Adding'; }
    else if (btn.dataset.ccwLabel) { btn.textContent = btn.dataset.ccwLabel; }
  }

  function notifyTheme(cartJson) {
    var emitted = false;
    try {
      if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents && cartJson && cartJson.sections) {
        window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: cartJson });
        emitted = true;
      }
    } catch (e) { emitted = false; }
    if (!emitted) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
    }
  }

  // Hidden line item properties (underscore prefix = not shown to the customer). They reach the
  // order, so reporting and Shopify Flow can tell a card-assisted add from a manual one.
  function attribution(btn) {
    var group = btn && btn.closest ? btn.closest('[data-ccw-addon-group]') : null;
    var props = { _ccw_addon: 'cart-card' };
    if (group && group.getAttribute('data-bundle-handle')) props._ccw_addon_for = group.getAttribute('data-bundle-handle');
    return props;
  }

  function addVariant(variantId, btn) {
    setBusy(btn, true);
    var body = {
      items: [{ id: Number(variantId), quantity: 1, properties: attribution(btn) }],
      sections: SECTIONS,
      sections_url: window.location.pathname
    };
    return fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
      .then(function (r) {
        if (!r.ok) throw new Error((r.json && (r.json.description || r.json.message)) || 'Could not add to cart');
        // /cart/add.js returns the added items; fetch the full cart with sections for the theme
        return fetch(rootUrl() + 'cart.js?sections=' + encodeURIComponent(SECTIONS), { headers: { 'Accept': 'application/json' } })
          .then(function (res) { return res.json(); });
      })
      .then(function (cartJson) { notifyTheme(cartJson); })
      .catch(function (err) {
        setBusy(btn, false);
        if (window.MinimogTheme && window.MinimogTheme.Notification && btn) {
          window.MinimogTheme.Notification.show({ target: btn.closest('[data-ccw-addon-card]') || btn, type: 'warning', message: err.message });
        }
      });
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest && ev.target.closest('[data-ccw-addon-add]');
    if (!btn) return;
    ev.preventDefault();
    addVariant(btn.getAttribute('data-variant-id'), btn);
  });

  /* ---------- keep trim resolution current across re-renders ---------- */
  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(resolve, 50); }

  document.addEventListener('cart:updated', schedule);
  document.addEventListener('cart:refresh', function () { setTimeout(resolve, 600); });

  function observe() {
    var targets = ['MinimogCartDrawerBody', 'MinimogCartBody'];
    for (var i = 0; i < targets.length; i++) {
      var el = document.getElementById(targets[i]);
      if (!el) continue;
      new MutationObserver(function (muts) {
        for (var m = 0; m < muts.length; m++) {
          var t = muts[m].target;
          if (t && t.nodeType === 1 && t.closest && t.closest('[data-ccw-addon-card]')) continue; // our own hidden toggles
          return schedule();
        }
      }).observe(el, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { resolve(); observe(); });
  } else {
    resolve(); observe();
  }

  window.CCWCartAddon = { resolve: resolve, garage: garage, add: addVariant };
})();
